import type { JournalPluginConfig } from "./types";
import { readPluginConfigString } from "../../../util/readPluginConfigString";

function parseJsonIfString<T>(raw: unknown): T | undefined {
  if (raw == null) return undefined;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw) as T;
    } catch {
      return undefined;
    }
  }
  return raw as T;
}

function readRichTextField(obj: Record<string, unknown>, key: string): string | undefined {
  const direct = readPluginConfigString(obj, key);
  if (direct) {
    return direct;
  }

  const value = obj[key];
  if (value && typeof value === "object") {
    const html = (value as { html?: unknown }).html;
    if (typeof html === "string" && html.length > 0) {
      return html;
    }
  }

  return undefined;
}

export function parseJournalPluginConfig(raw: unknown): JournalPluginConfig {
  const obj = parseJsonIfString<Record<string, unknown>>(raw) ?? {};

  return {
    activityLabel: readRichTextField(obj, "activityLabel"),
    activityTitle: readRichTextField(obj, "activityTitle"),
    instructions: readRichTextField(obj, "instructions"),
    captions: readRichTextField(obj, "captions"),
    credit: readRichTextField(obj, "credit"),
    itemId: readPluginConfigString(obj, "itemId"),
  };
}
